import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { map, catchError, BehaviorSubject, Observable } from 'rxjs';
import { AuthServiceService } from './auth-service.service';

@Injectable({
    providedIn: 'root',
})
export class TicketsService {


    // _liveApiUrl: any = this.authService._liveApiUrl;
    get _liveApiUrl() {
        return this.authService._liveApiUrl;
    }

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private toastr: ToastrService,
        public authService: AuthServiceService
    ) { }

    createTicket(form: any) {
        return this.http.post<any>(`${this._liveApiUrl}/helpdesk/ticket/`, form).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    deleteTicket(id: any) {
        return this.http.delete<any>(`${this._liveApiUrl}/helpdesk/ticket/${id}`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    deleteTicket2(id: any) {
        let schema = localStorage.getItem('tickets_schema_name') || 'null';
        const params = new HttpParams()
            .set('schema', schema)
            .set('ticket_type', 'nongenric');

        return this.http.delete<any>(
            `${this._liveApiUrl}/helpdesk/ticket/${id}`,
            { params }
        ).pipe(
            map((data: any) => data),
            catchError(this.authService.handleError)
        );
    }

    deleteTicket1(id: any, schemaName?: string) {
        return this.http.delete<any>(
            `${this._liveApiUrl}/helpdesk/ticket/${id}?schema=${schemaName}&ticket_type=nongeneral`
        ).pipe(
            map((data: any) => data),
            catchError(this.authService.handleError)
        );
    }


    getTickets(page: any, val: any, status: any, searchVal: any, tabNames?: any, isReceiving: boolean = false) {
        let tail = '';
        let label = '';
        if (isReceiving) {
            label = "my";
        } else {
            if (val == "driver") {
                label = "driver";
            } else if (val == "customer") {
                label = "customer";
            } else if (val == "my") {
                label = "my";
            }
            else if (val == "company") {
                label = "Organization Admin";
            }
        }

        if (tabNames == 'ACT') {
            tabNames = 'Nongeneral'
        }
        if (tabNames == 'APO') {
            tabNames = 'general'
        }
        let params = new URLSearchParams();
        if (params) {
            if (label && label.length > 0) {
                params.set('label', label)
            }
            if (status && status.length > 0) {

                // 🔥 Special case for ALL
                if (status === "all") {
                    params.set('status', 'all_ticket');
                } else {
                    params.set('status', status);
                }

            }

            if (searchVal && searchVal.length > 0) {
                params.set('search_text', searchVal)
            }
            if (tabNames && tabNames.length > 0 && val == 'MT') {
                params.set('ticket_type', tabNames)
            }
            if (isReceiving) {
                if (val === 'po') {
                    params.set('ticket_type', 'general');
                    params.set('is_receiving_admin', 'true');
                } else {
                    params.set('ticket_type', 'Nongeneral');
                }
            }
            if (page) {
                params.set('page', page)
            }
        }
        if (label || status || page || searchVal) {
            tail += `?` + params.toString();
        }
        return this.http.get<any>(`${this._liveApiUrl}/helpdesk/ticket-listing/${tail}`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    getreciverTickets(page: any, val: any, status: any, searchVal: any, tabNames?: any) {
        let tail = '';
        let label = '';
        if (val == "DT") {
            label = "driver";
        } else if (val == "CT") {
            label = "customer";
        } else if (val == "MT") {
            label = "my";
        }
        else if (val == "RT") {
            label = "Organization Admin";
        }

        if (tabNames == 'RCT') {
            tabNames = 'Nongeneral'
        }
        if (tabNames == 'RPO') {
            tabNames = 'general'

        }
        let params = new URLSearchParams();
        if (params) {
            if (label && label.length > 0) {
                params.set('label', label)
            }
            if (status && status.length > 0) {
                params.set('status', status)
            }
            if (searchVal && searchVal.length > 0) {
                params.set('search_text', searchVal)
            }
            if (tabNames && tabNames.length > 0 && val == 'MT') {
                params.set('ticket_type', tabNames)
            }
            if (tabNames == 'general') {
                params.set('is_receiving_admin', 'true')
            }
            if (page) {
                params.set('page', page + 1)
            }
        }
        if (label || status || page || searchVal) {
            tail += `?` + params.toString();
        }
        return this.http.get<any>(`${this._liveApiUrl}/helpdesk/ticket-listing/${tail}`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    getTicketsCount() {
        return this.http.get<any>(`${this._liveApiUrl}/helpdesk/ticket-count/?is_shipped_admin=true`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    getReciverTicketsCount() {
        return this.http.get<any>(`${this._liveApiUrl}/helpdesk/ticket-count/?is_receiving_admin=true`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }

    getTicketDetails1(id: any, schemaName?: string) {
        return this.http.get<any>(`${this._liveApiUrl}/helpdesk/ticket-datails/${id}?schema=${schemaName}`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    getrecivingTicketDetails1(id: any, schemaName?: string) {
        return this.http.get<any>(`${this._liveApiUrl}/helpdesk/ticket-datails/${id}?schema=${schemaName}&ticket_type=nongeneral`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    getTicketDetails(id: any, schema?: string, ticketType?: string) {
        let params = new HttpParams();
        if (schema) {
            params = params.set('schema', schema);
        }
        if (ticketType) {
            params = params.set('ticket_type', ticketType);
        }

        return this.http.get<any>(`${this._liveApiUrl}/helpdesk/ticket-datails/${id}`, { params }).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    getTicketDetails4(id: any) {
        const schema = localStorage.getItem('tickets_schema_name') || 'null';
        const params = new HttpParams()
            .set('schema', schema)
            .set('ticket_type', 'nongenric');

        return this.http.get<any>(
            `${this._liveApiUrl}/helpdesk/ticket-datails/${id}`,  // ✅ Only the URL here
            { params }                                             // ✅ Second argument: options
        ).pipe(
            map((data: any) => data),
            catchError(this.authService.handleError)
        );
    }

    sendChat(form: any) {
        return this.http.post<any>(`${this._liveApiUrl}/helpdesk/send-chat/`, form).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    messageRead(id: any) {
        return this.http.put<any>(`${this._liveApiUrl}/helpdesk/message-read/${id}/`, {}).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    messageRead1(id: any, schemaName?: string) {
        return this.http.put<any>(`${this._liveApiUrl}/helpdesk/message-read/${id}/?schema=${schemaName}`, {}).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    getStatusCount(val: any, tabNames?: any, isReceiving: boolean = false) {
        let created_by = '';
        if (tabNames == 'ACT') {
            tabNames = 'Nongeneral'
        }
        if (tabNames == 'APO') {
            tabNames = 'general'
        }
        if (tabNames == 'RPO') {
            tabNames = 'general'
        }
        if (tabNames == 'RCT') {
            tabNames = 'Nongeneral'
        }
        if (isReceiving) {
            created_by = "my";
        } else {
            if (val == "driver") {
                created_by = "driver";
            } else if (val == "customer") {
                created_by = "customer";
            } else if (val == "my") {
                created_by = "my";
            }
            else if (val == "company") {
                created_by = "Organization Admin";
            }
        }
        let tail = '';
        let params = new URLSearchParams();
        if (params) {
            if (created_by && created_by.length > 0) {
                params.set('created_by', created_by)
            }
        }
        if (tabNames && tabNames.length > 0 && val == 'MT') {
            params.set('ticket_type', tabNames)
            params.set('is_shipped_admin', 'true')
        }
        if (isReceiving) {
            if (val === 'po') {
                params.set('ticket_type', 'general');
            } else {
                params.set('ticket_type', 'Nongeneral');
            }
            params.set('is_receiving_admin', 'true');
        }
        if (created_by && created_by.length > 0) {
            tail += `?` + params.toString();
        }
        return this.http.get<any>(`${this._liveApiUrl}/helpdesk/ticket-status-count/${tail}`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    getReciverStatusCount(val: any, tabNames?: any) {
        let created_by = '';
        if (tabNames == 'ACT') {
            tabNames = 'Nongeneral'
        }
        if (tabNames == 'APO') {
            tabNames = 'general'
        }
        if (tabNames == 'RPO') {
            tabNames = 'general'
        }
        if (tabNames == 'RCT') {
            tabNames = 'Nongeneral'
        }
        if (val == "DT") {
            created_by = "driver";
        } else if (val == "CT") {
            created_by = "customer";
        } else if (val == "MT") {
            created_by = "my";
        }
        else if (val == "RT") {
            created_by = "Organization Admin";
        }
        let tail = '';
        let params = new URLSearchParams();
        if (params) {
            if (created_by && created_by.length > 0) {
                params.set('created_by', created_by)
            }
        }
        if (tabNames && tabNames.length > 0 && val == 'MT') {
            params.set('ticket_type', tabNames)
            params.set('is_receiving_admin', 'true')
        }
        if (created_by && created_by.length > 0) {
            tail += `?` + params.toString();
        }
        return this.http.get<any>(
            `${this._liveApiUrl}/helpdesk/ticket-status-count/${tail}`
        ).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }
    private companyData: { address: object[] } = { address: [] };
    private _company = new BehaviorSubject<object[]>([]);
    addressSearch(page: any, searchVal?: string) {
        let queryString = '';
        if (page) {
            queryString = `page=${page}`;
        }
        if (searchVal) {
            queryString += (queryString ? "&" : "") + "search_text=" + encodeURIComponent(searchVal);
        }

        this.http
            .get<any>(`${this._liveApiUrl}/customer/company-listing/?${queryString}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
            .subscribe(
                (data: any) => {
                    if (data.errorMessage === 'Invalid page number' && page > 1) {
                        localStorage.setItem('addressslistingpageno', (page - 1).toString())
                        this.addressSearch(page - 1)
                        return
                    }

                    this.companyData.address = data;
                    this._company.next(Object.assign({}, this.companyData).address);
                },
                (error) => {
                    this.authService.dataError(error);
                }
            );
    }
    getCompany(): Observable<any[]> {
        return this._company.asObservable();
    }
}